export const GuestsIcon = (props) => {
  // const { className } = props;

  return <h5 style={{ marginBottom: 0 }}>G</h5>;
};
